import React from 'react'
import { motion } from 'framer-motion'
import { AppWrapper } from '../../HOC'
import { images } from '../../constants'
import './header.scss'

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text">Gamarjoba, I am</p>
              <h1 className="head-text">Juba</h1> 
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <p className="p-text">Software Engineer</p>
            <p className="p-text">Solutions Architect</p>
            <p className="p-text">Cybersecurity Specialist</p>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileInView={{  qopacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        <img src={images.profile} alt="profile-img" />
        <motion.img
          whileInView={{  scale: [0, 1] }}
          transition={{ duration: 1, ease: "easeInOut" }}
          className="overlay_circle"        
          src={images.circle}
          alt="profile-img"
        />
      </motion.div>
      <motion.div 
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {[images.cybersec, images.web, images.mobdev].map((circle) => (
          <div className="circle-cmp app__flex" key={`circle${circle}`}>
            <img src={circle} alt='circles' />
          </div>
        ))}
      </motion.div>
    </div>
  )
}

export default AppWrapper(Header, 'home')